import React from 'react';

import OrdersAdvancedSearchContainer from './redux-container';
import { AdvancedSearchOrderContextProvider } from './context';
import { PagingContextProviderContainer } from '../../contexts/paging-context/container';

const OrdersAdvancedSearch = () => {
  return (
    <PagingContextProviderContainer>
      <AdvancedSearchOrderContextProvider>
        <OrdersAdvancedSearchContainer />
      </AdvancedSearchOrderContextProvider>
    </PagingContextProviderContainer>
  );
};

export default OrdersAdvancedSearch;
